import { render, staticRenderFns } from "./CurrencyBar.vue?vue&type=template&id=339916cd&"
import script from "./CurrencyBar.vue?vue&type=script&lang=ts&"
export * from "./CurrencyBar.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports